<div class="information-dialog-container popup-container">
  <div class="information-header">
    <span class="information-title">{{ 'dialog.information' | translate }}</span>
  </div>

  <div class="information-list">
    <span>{{ 'informations-dialog.player-code' | translate }}  {{playerCode$ | async}} </span>
    <span>{{ 'informations-dialog.player' | translate }}  {{playerName$ | async}} </span>
    <span>{{ 'informations-dialog.player-version' | translate }}  {{environment.appVersion}}</span>
    <span>{{ 'informations-dialog.last-update' | translate }}  {{lastUpdate$ | async}}</span>
    <span style="color: red;" *ngIf="syncErrorMessage">{{syncErrorMessage}}</span>
    <span>{{ 'informations-dialog.playlist-quantity' | translate }}  {{playlistNumber}}</span>
    <span>{{ 'informations-dialog.media-quantity' | translate }}  {{mediaNumber}}</span>
  </div>

</div>
